<template>
    <v-card flat class="pa-5">
        <v-menu
            :close-on-content-click="false"
            v-model="datepicker"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
        >
            <v-text-field
              slot="activator"
              v-model="incomeInvoiceDate"
              label="Date"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker 
              v-model="incomeInvoiceDate"
              @input="datepicker = false"
            />
        </v-menu>

        <v-select 
            v-model="selectedFirmFromIncome"
            :items="firmsByBrand"
            label="From Firm"
            required>
            <template slot="selection" slot-scope="data">
                {{ data.item.text }}
            </template>
            <template slot="item" slot-scope="data">
                <v-list-tile-content>
                    <v-list-tile-title 
                        v-html="`${data.item.firm.name}${data.item.firm.proprietor ? ' | '+data.item.firm.proprietor : '' } | ₹: ${(data.item.firm.amount || 0).toLocaleString()}`" />
                </v-list-tile-content>
            </template>
        </v-select>
        <v-select 
            v-bind:items="incomeByBrand"
            v-model="selectIncome" 
            label="Select or add Income"
            autocomplete
            @keyup.native.enter="addIncome"
        />
        <span class="error--text" v-if="addError">{{addError}}</span>
        <v-select
            v-if="selectIncome"
            :disabled="!!selectedIncomeType.category"
            v-bind:items="categotyList"
            v-model="incomeCategory" 
            label="Select Income Category"
        />
        <v-select 
            v-if="selectIncome && incomeCategory"
            :disabled="!!selectedIncomeType.underHead"
            v-bind:items="underHeadList"
            v-model="incomeUnderHead" 
            label="Select Income UnderHead"
        />
        <div v-if="selectIncome && incomeCategory && incomeUnderHead && (!firmIncame.length) && !selectedFirmOpeningBalance">
            <b class="subheading primary--text font-weight-bold"> is Opening Balance Available For 
                <!-- {{selectIncome}} -->
            </b>    
        </div>
            <v-radio-group 
                v-model="isOpeningBalance" 
                row 
                v-if="selectIncome && incomeCategory && incomeUnderHead && (!firmIncame.length)">

                <v-radio 
                    label="New" 
                    :value="true">
                    <template v-slot:label>
                        <div>
                            <strong class="success--text"> Yes </strong>
                        </div>
                    </template>
                </v-radio>

                <v-radio 
                    label="old" 
                    :value="false">
                    <template v-slot:label>
                        <div>
                            <strong class="primary--text"> No </strong>
                        </div>
                    </template>
                </v-radio>
            </v-radio-group>
            
            <v-text-field 
                type="number"
                v-if="(selectIncome && incomeCategory && incomeUnderHead && isOpeningBalance && !firmIncame.length) && !selectedFirmOpeningBalance"
                label="Opening Balance" 
                v-model="incomeOpeningBalance">
            </v-text-field>
            <b v-if="selectIncome && incomeCategory  && incomeOpeningBalance && isOpeningBalance" class="subheading primary--text font-weight-bold"> Payment Type </b>
            <v-radio-group
                v-if="selectIncome && incomeCategory  && incomeOpeningBalance && isOpeningBalance" 
                v-model="incomeVia"  
                :mandatory="false" 
            row>
                <!-- <v-radio label="From Cash" value="cash"></v-radio>
                <v-radio label="From Bank Account" value="account"></v-radio> -->
                <v-radio label="From Provision" value="provision"></v-radio>
            </v-radio-group>


            <v-text-field 
                label="Amount" 
                v-model="incomeAmount" 
                :hint="hintText"
                v-if="selectIncome && incomeCategory && incomeUnderHead && !isOpeningBalance"
                required>
            </v-text-field>
            
            <b v-if="selectIncome && incomeCategory && incomeUnderHead && incomeAmount && !isOpeningBalance" class="primary--text font-weight-bold"> Payment Type </b>
            
            <v-radio-group
                v-if="selectIncome && incomeCategory && incomeUnderHead && incomeAmount && !isOpeningBalance" 
                v-model="incomeVia"  
                :mandatory="false" 
                row>
                <v-radio label="To Cash" value="cash"></v-radio>
                <v-radio label="To Bank Account" value="account"></v-radio>
                <v-radio label="To Provision" value="provision"></v-radio>
            </v-radio-group>
              <v-select 
                v-if="incomeVia == 'account'" 
                    v-model="selectAccountFromIncome"
                    :items="banksByFirm"
                    label="From Bank Account"
                    :disabled="!selectedFirmFromIncome"
                    required
                >
                <template slot="selection" slot-scope="data">
                    {{ data.item.account.accountnumber }}{{data.item.account.bankName ? ' | '+data.item.account.bankName : '' }}
                </template>
                <template slot="item" slot-scope="data">
                    <v-list-tile-content>
                        <v-list-tile-title v-html="`${data.item.account.accountnumber}
                            ${data.item.account.bankName ? ' | '+data.item.account.bankName : '' }
                            ${data.item.account.accountType ? ' | '+data.item.account.accountType : '' }
                            | ₹: ${(data.item.account.amount || 0).toLocaleString()}`
                        " />
                    </v-list-tile-content>
                </template>
            </v-select>
            <v-text-field 
                label="Remark" 
                v-model="incomeRemark"
                v-if="selectIncome && incomeCategory && incomeUnderHead && incomeOpeningBalance || incomeAmount"
                :disabled="selectedIncomeType.incomeRemark" >
            </v-text-field>
            
            <v-btn color="primary" @click="incomeAmountClick">
            <v-icon dark>money_off</v-icon> &nbsp; Save
            </v-btn>
            
            <v-btn color="primary" @click="$router.go(-1)">
            <v-icon dark>cancel</v-icon> &nbsp; Cancel 
            </v-btn>

            <v-btn round outline class="primary--text font-weight-bold" @click="openIncomeTable = true">
                <v-icon dark> remove_red_eye </v-icon> 
                  &nbsp;  Income Table 
            </v-btn>
            <v-btn round outline class="primary--text font-weight-bold" @click="openProvisionTable = true">
                <v-icon dark> remove_red_eye </v-icon> 
                  &nbsp;  Provision Table 
            </v-btn>
                <v-dialog
                    fullScreen
                    v-model="openIncomeTable"
                    transition="dialog-bottom-transition"
                >
                    <v-toolbar card dark color="primary">
                        <v-toolbar-title>Income Details</v-toolbar-title>
                        <v-spacer/>
                        <v-btn icon dark @click.native="openIncomeTable = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card>
                        <income-table-info :accountsByBrand="accountsByBrand" :firmsByBrand="firmsByBrand" />
                    </v-card>
                </v-dialog>
                <v-dialog
                    fullScreen
                    v-model="openProvisionTable"
                    transition="dialog-bottom-transition"
                >
                    <v-toolbar card dark color="primary">
                         <v-flex xs12 md3>
                            <v-select
                                class="select-firm"
                                :items="firmsByBrand"
                                label="Select Firm"
                                v-model="selectedFirmProvisionFilter"
                            ></v-select>
                            </v-flex>
                              <v-flex xs12 md3>
                                <h3>
                                    <p style="text-align: center;"> <v-toolbar-title>Provision Details</v-toolbar-title></p>
                                </h3>
                                </v-flex>   
                        <v-spacer/>
                        <v-btn icon dark @click.native="openProvisionTable = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card>
                        <v-data-table :items="provisionByBrand" class="elevation" :headers="provisionHeader">
                            <template slot="items" slot-scope="props">
                            <td>{{ props.item['.key'] }}</td>
                            <td><b class="font-weight-bold">{{ getFirmName(props.item.firm) }}</b></td>
                            <td>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</td>
                            <td>{{ props.item.openingBalance || 0 | amount }}</td>
                            <td v-if="!props.item['isCredited']">
                                <b  class="success--text font-weight-bold">{{ props.item.credit || 0 | amount }}</b>
                            </td>
                            <td v-else></td>
                            <td v-if="props.item['isCredited']" >
                                 <b class="error--text font-weight-bold">{{ props.item.debit || 0 | amount }}</b>
                            </td>
                             <td v-else></td>
                             <td>
                                 <b >{{ props.item.RunningBal || 0 | amount }}</b>
                            </td>
                            <!-- <td>{{ getTotalAmount(props.item)|| 0 | amount }}</td> -->
                            <td>{{ ((props.item.openingBalance ?  props.item.totalAmount : 0 ) + (props.item.totalAmount ? props.item.totalAmount : 0) ) || 0| amount }}</td>
                            <td>{{ props.item.paymentType }}</td>
                            <td>{{ props.item.remark}}</td>
                            <td><b>{{ props.item.paymentTypeStatus || "yet to confirm/confirm" }}</b></td>
                            </template>
                            <template slot="no-data">no record found</template>
                         </v-data-table>
                    </v-card>
                </v-dialog>
            </v-card>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
import incomeTableInfo from '../table/incomeTable.vue';
import {digitsToWords} from '../../../utils/digitsToWords.js'

export default {
    name: 'incomeTab',
    props: {
        selectedBrand: { type: String },
        accountsByBrand: { type: Array },
        firmsByBrand: { type: Array },
    },
    components: {
        incomeTableInfo
    },
    data() {
        return {
            openIncomeTable: false,
            openProvisionTable : false,
            datepicker: false,
            selectedFirm : this.firmsByBrand[0].value,
            selectedFirmFromIncome:this.firmsByBrand[0].value,
            isOpeningBalance : null,
            selectAccountFromIncome:null,
            categotyList: ['Direct', 'Indirect'],
            underHeadList: ['Prop Capital A/C', 'Profit and Loss'],
            incomeInvoiceDate: null,
            hintText : null,
            incomeVia: 'cash',
            addError : null,
            selectIncome: null,
            incomeCategory: null,
            incomeUnderHead: null,
            incomeOpeningBalance: null,
            incomeRemark: null,
            incomeAmount: null,
            selectedFirmOpeningBalance : null,
            firmIncame : [],
            selectedFirmProvisionFilter : null,
            provisionHeader : [
                { text: "Id", value: ".key", sortable: false },
                { text: "Firm Name", value: "firm", sortable: true },
                { text: "Date", value: "income", sortable: true },
                { text: "Opening WDV", value: "openingBalance", sortable: false },
                { text: "Credit", value: "totalAmount", sortable: false },
                { text: "Debit", value: "totalAmount", sortable: false },
                { text: "Running Balance", value: "totalAmount", sortable: false },
                { text: "Closing WDV", sortable: false },
                { text: "paymentType", value: ".key", sortable: false },
                { text: "remark", value: "type", sortable: true },
                { text: "paymentTypeStatus", value: "paymentTypeStatus", sortable: false },
            ],
        }
    },
    created() {
        this.$bindAsArray('provisionIncome', this.$root.$firebaseRefs.provisionIncome.orderByChild('brand').equalTo(this.selectedBrand)),
        this.$bindAsArray('banks', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand)),
        this.$bindAsArray("firmList", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)),
        this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand)),
        this.$bindAsArray("incomes", this.$root.$firebaseRefs.incomes.orderByChild('brand').equalTo(this.selectedBrand));
        let today = new Date()
        this.incomeInvoiceDate = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`
    },
    computed: {
        ...mapGlobalGetters(["brandFinYear"]),
        incomeByBrand() {
            return this.incomes.filter((item) =>
            item['brand'] === this.selectedBrand
            ).map(item =>{
                return{
                    income: item,
                    text : item['income'],
                    value: item['.key']
                }
            })
        },
        banksByFirm(){
            return this.banks.filter((item) => 
                item['brand'] === this.selectedBrand 
                && item['firm'] == (this.selectedFirmFromIncome.value ||this.selectedFirmFromIncome)

            ).map(item => {
            return {
                account: item,
                text: item['accountnumber'],
                value: item['.key']
            }
            })
        },
        provisionByBrand() {
            let provision =  this.provisionIncome.filter((item) =>
            item['brand'] === this.selectedBrand && 
             ( this.selectedFirmProvisionFilter ? this.selectedFirmProvisionFilter === item["firm"] : true)
            )
            provision.map((p,index)=>{
                if(p.isCredited) {
                    provision[index]["debit"] = provision[index]["totalAmount"]
                    provision[index]["credit"] = 0
                } else {
                    provision[index]["credit"] = provision[index]["totalAmount"]
                    provision[index]["debit"] = 0
                }
                provision[index]["RunningBal"] =
                Number.parseFloat(provision[index]["debit"]) -
                Number.parseFloat(provision[index]["credit"]) +
                (index == 0 ? 0 :  Number.parseFloat(provision[index]["RunningBal"]));
                    });
            return provision;
        },
        selectedIncomeType() {
            if(this.selectIncome) {
                const income = this.incomes.find(item => item['.key'] === this.selectIncome);
                this.incomeUnderHead = income.underHead;
                this.incomeCategory = income.category;
                return income
            }
            return {}
        }
    },
    watch: {
            "selectedFirmFromIncome": {
                handler(newVal, oldVal) {
                    if(newVal != oldVal) {
                    // let firm = this.firmList.filter(item => item[".key"] === newVal)[0];  
                    // this.selectedFirmOpeningBalance = firm.openingBalance
                    this.getFirmIncome();
                    }
                },
                deep: true
            },
            "selectIncome": {
                handler(newVal, oldVal) {
                    if(newVal != oldVal) {
                    this.getFirmIncome();
                    }
                },
                deep: true
            },
            "incomeAmount" : {
                handler(){
                    this.hintText = this.incomeAmount ? _.startCase(digitsToWords(Number.parseFloat(this.incomeAmount))) : null
                },
                deep : true
            },
    },
    methods: {
        getFirmIncome(){
            this.selectedFirm = this.firmsByBrand.filter(item => item['value'] == this.selectedFirmFromIncome)[0]
            console.log(this.selectedFirm)
            let firmIncome = this.invoices.filter(item => (item["firm"] === this.selectedFirmFromIncome && item["incomeType"] === this.selectIncome))
            this.firmIncame = firmIncome;
            let openingBalance = 0;
            firmIncome.map((inv)=>{
                openingBalance += (inv.openingBalance ? parseInt(inv.openingBalance) : 0);
            });
            this.selectedFirmOpeningBalance = openingBalance;
        },
        getFirmName(e){
          let firm;
          if (this.firmList && this.selectedBrand) {
            firm =this.firmList.filter(item => item['.key'] === e)[0]
          }
          if(firm)
          return firm.name
        },
        reset() {
            this.incomeAmount = null;
            this.selectedFirmFromIncome = null;
            this.selectAccountFromIncome = null;
            this.incomeRemark = null;
            this.selectIncome = null;
            this.incomeVia = null;
            this.incomeCategory = null;
            this.incomeUnderHead = null;
            this.incomeOpeningBalance = null;
            let today = new Date()
            this.incomeInvoiceDate = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`;
            this.firmIncame = [];
            this.selectedFirmOpeningBalance = null;
            this.$emit('closedialog');
        },
        incomeAmountClick:function(e){
            if(this.incomeRemark !=null) {
                if(this.selectIncome != null) {
                    // incomeData updated with category and underhead on income create
                    if(this.IncomeCategory !== this.selectedIncomeType.category || this.incomeUnderHead !== this.selectedIncomeType.underHead) {
                        this.$root.$firebaseRefs.incomes.child(this.selectIncome).update({
                            category: this.incomeCategory,
                            underHead: this.incomeUnderHead
                        })
                    }
                    if(this.incomeVia == 'cash'){
                        this.$root.$firebaseRefs.firm.child(this.selectedFirmFromIncome).once('value').then((snap) => {
                            // if(Number(snap.val().amount) >= this.incomeAmount){
                                this.$root.$firebaseRefs.firm.child(this.selectedFirmFromIncome).update({
                                    amount: Number(snap.val().amount) + Number(this.incomeAmount)
                                });
                                setTimeout(() => {
                                    this.addInvoiceIncome({
                                        incomeVia: this.incomeVia,
                                        incomeType: this.selectIncome,
                                        firmOfIncome: this.selectedFirmFromIncome,
                                        incomeAmount: this.incomeAmount,
                                        incomeRemark: this.incomeRemark,
                                        openingBalance : this.incomeOpeningBalance
                                    })
                                })
                            // } else{
                            //     this.$emit('notify','Insufficient Balance')
                            // }
                        })
                    } else if(this.incomeVia == 'account') {
                        let incomeAccountFirm= null;
                        let incomeAccountNumber =null;
                        this.$root.$firebaseRefs.account.child(this.selectAccountFromIncome).once('value').then(snap => {
                            incomeAccountFirm = snap.val().firm;
                            incomeAccountNumber = snap.val().accountnumber;
                            // if(Number(snap.val().amount) >= this.incomeAmount){
                                this.$root.$firebaseRefs.account.child(this.selectAccountFromIncome).update({
                                    amount: Number(snap.val().amount) + Number(this.incomeAmount)
                                });
                                this.$emit('notify', "income amount Received", true);
                                setTimeout(() => {
                                    this.addInvoiceIncome({
                                        incomeVia: this.incomeVia,
                                        incomeType: this.selectIncome,
                                        firmOfIncome: incomeAccountFirm, 
                                        incomeAmount: this.incomeAmount,
                                        incomeRemark: this.incomeRemark,
                                        accountOfIncome: incomeAccountNumber,
                                        openingBalance : this.incomeOpeningBalance,
                                    })
                                })
                            // } else{
                            //     this.$emit('notify','Insufficient Balance')
                            // }
                        })
                    } else {
                        this.addInvoiceIncome({
                            incomeVia: this.incomeVia,
                            incomeType: this.selectIncome,
                            firmOfIncome: this.selectedFirmFromIncome, 
                            incomeAmount: this.incomeAmount,
                            incomeRemark: this.incomeRemark,
                            openingBalance : this.incomeOpeningBalance
                        })  
                    }
                } else {
                    this.$emit('notify','Please enter a Income type')
                }
            } else {
                this.$emit('notify','Please enter a Remark')
            }
        },
        addIncome:function(e){
            let incomeData = {
                brand: this.selectedBrand,
                income: e.target.value,
                category: null,
                underHead: null,
            }
            let availableIncomes = this.incomes.filter(item => item.income ==  e.target.value && item['brand'] === this.selectedBrand);
            if(availableIncomes.length) {
                this.addError = 'Income with name ' + e.target.value + ' Already exist.';
                setTimeout(() => {
                    this.addError = null;
                }, 3000);
            } else {
                this.$root.$firebaseRefs.incomes.push(incomeData);
            }
            // push income without category and underhead
            
        },
        // income Invoice
        addInvoiceIncome({ incomeVia, incomeType, firmOfIncome, incomeAmount, incomeRemark, accountOfIncome,openingBalance}) {
            if(incomeVia == 'cash'){
                let invoiceViaCash = {
                    brand: this.selectedBrand,
                    brandFinYear : this.brandFinYear,
                    type:'automatic invoice',
                    transactionType: 'income',
                    firm:firmOfIncome,
                    paymentType:incomeVia,
                    accountNumber:'',
                    paymentTypeStatus : 'confirm',
                    isCredited:true,
                    totalAmount:Number(incomeAmount),
                    remark:incomeRemark,
                    incomeType:incomeType,
                    openingBalance : openingBalance,
                    date: this.incomeInvoiceDate ? Date.parse(this.incomeInvoiceDate) : Date.now()
                }
                this.$root.$firebaseRefs.invoice.push(invoiceViaCash, () => {
                    this.$emit('notify', "Amount received", true);
                    this.reset();
                });
            } else if(incomeVia == 'account') {
                let invoiceViaAccount = {
                    brand: this.selectedBrand,
                    brandFinYear : this.brandFinYear,
                    type:'automatic invoice',
                    transactionType: 'income',
                    firm:firmOfIncome,
                    paymentType:incomeVia,
                    accountNumber:accountOfIncome,
                    isCredited:true,
                    bank : this.selectAccountFromIncome,
                    paymentTypeStatus : 'confirm',
                    totalAmount:Number(incomeAmount),
                    remark:incomeRemark,
                    incomeType:incomeType,
                    openingBalance : openingBalance,
                    date: this.incomeInvoiceDate ? Date.parse(this.incomeInvoiceDate) : Date.now()
                }
                this.$root.$firebaseRefs.invoice.push(invoiceViaAccount, () => {
                    this.$emit('notify', "Amount received", true);
                    this.reset();
                });
            } else {
                 let invoiceViaAccount = {
                    brand: this.selectedBrand,
                    brandFinYear : this.brandFinYear,
                    type:'automatic invoice',
                    transactionType: 'income',
                    firm:firmOfIncome,
                    paymentType:incomeVia,
                    accountNumber:'',
                    isCredited:true,
                    paymentTypeStatus : 'yet to confirm',
                    totalAmount:Number(incomeAmount),
                    remark:incomeRemark,
                    incomeType:incomeType,
                    openingBalance : openingBalance,
                    date: this.incomeInvoiceDate ? Date.parse(this.incomeInvoiceDate) : Date.now()
                }
                let res = this.$root.$firebaseRefs.invoice.push(invoiceViaAccount)
                console.log(res)
                if(res.key) {
                    invoiceViaAccount['invoiceId'] = res.key
                    this.$root.$firebaseRefs.provisionIncome.push(invoiceViaAccount, () => {
                        this.$emit('notify', "Amount received", true);
                        this.reset();
                    });
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/InvoiceManagement/tabs/income.vue